"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IconRotateCounterClockwiseOutline = _interopRequireDefault(require("./IconRotateCounterClockwiseOutline"));
var StyledIconRotateClockwiseOutline = /*#__PURE__*/(0, _styledComponents.default)(_IconRotateCounterClockwiseOutline.default).withConfig({
  displayName: "StyledIconRotateClockwiseOutline",
  componentId: "c11n-8-107-0__sc-1jnv8xe-0"
})(["transform:scaleX(-1);"]);
var IconRotateClockwiseOutline = function IconRotateClockwiseOutline(props) {
  return /*#__PURE__*/_react.default.createElement(StyledIconRotateClockwiseOutline, props);
};
var _default = IconRotateClockwiseOutline;
exports.default = _default;